<nav class="menu" >
  <div class="logo">
    <img src="assets/images/logo.svg" alt="Logo" width="150" height="40" style="max-width: 150px; height: auto;">
  </div>
  
  <div class="nav-items" >
    <!-- Websites Dropdown -->
    <div class="relative dropdown" #websitesMenu>
      <button class="menu-button">
        <span class="flex items-center">
          <svg class="w-4 h-4 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" 
                  d="M3 12l2-2m0 0l7-7 7 7M5 10v10a1 1 0 001 1h3m10-11l2 2m-2-2v10a1 1 0 01-1 1h-3m-6 0a1 1 0 001-1v-4a1 1 0 011-1h2a1 1 0 011 1v4a1 1 0 001 1m-6 0h6" />
          </svg>
          Websites
          <svg class="w-4 h-4 ml-1" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 9l-7 7-7-7" />
          </svg>
        </span>
      </button>
      
      <div class="dropdown-menu">
        <div class="py-1">
          <a routerLink="/pages" routerLinkActive="active-item" class="menu-item">
            <svg class="w-4 h-4 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                    d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
            </svg>
            Pages
          </a>
          <a routerLink="/menu" routerLinkActive="active-item" class="menu-item">
            <svg class="w-4 h-4 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 6h16M4 12h16M4 18h16" />
            </svg>
            Menu
          </a>
          <a routerLink="/posts" routerLinkActive="active-item" class="menu-item">
            <svg class="w-4 h-4 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z" />
            </svg>
            
            Posts
          </a>
          <a routerLink="/settings" routerLinkActive="active-item" class="menu-item">
            
            <svg class="w-4 h-4 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" 
                    d="M10.325 4.317c.426-1.756 2.924-1.756 3.35 0a1.724 1.724 0 002.573 1.066c1.543-.94 3.31.826 2.37 2.37a1.724 1.724 0 001.065 2.572c1.756.426 1.756 2.924 0 3.35a1.724 1.724 0 00-1.066 2.573c.94 1.543-.826 3.31-2.37 2.37a1.724 1.724 0 00-2.572 1.065c-.426 1.756-2.924 1.756-3.35 0a1.724 1.724 0 00-2.573-1.066c-1.543.94-3.31-.826-2.37-2.37a1.724 1.724 0 00-1.065-2.572c-1.756-.426-1.756-2.924 0-3.35a1.724 1.724 0 001.066-2.573c-.94-1.543.826-3.31 2.37-2.37.996.608 2.296.07 2.572-1.065z" />
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" 
                    d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
            </svg>
            Settings
          </a>
          <a routerLink="/media" routerLinkActive="active-item" class="menu-item">
            <svg class="w-4 h-4 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" 
                    d="M4 16l4.586-4.586a2 2 0 012.828 0L16 16m-2-2l1.586-1.586a2 2 0 012.828 0L20 14m-6-6h.01M6 20h12a2 2 0 002-2V6a2 2 0 00-2-2H6a2 2 0 00-2 2v12a2 2 0 002 2z" />
            </svg>
            Media
          </a>
          <a routerLink="/projects" routerLinkActive="active-item" class="menu-item">
            <svg class="w-4 h-4 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" 
                    d="M21 13.255A23.931 23.931 0 0112 15c-3.183 0-6.22-.62-9-1.745M16 6V4a2 2 0 00-2-2h-4a2 2 0 00-2 2v2m4 6h.01M5 20h14a2 2 0 002-2V8a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
            </svg>
            Projecten
          </a>
        </div>
      </div>
    </div>

    <!-- Other menu items -->
    <ng-container *ngFor="let item of menuItems">
      <a *ngIf="isVisible(item.roles ?? [])"
         [routerLink]="item.path"
         routerLinkActive="active"
         class="menu-button">
        {{item.label}}
      </a>
    </ng-container>
  </div>

  <div class="domain-selector">
    <div class="flex items-center gap-2">
      <button (click)="openDomainSelectionModal()" class="domain-select-button">
        <span>{{ selectedDomain || 'Select Domain' }}</span>
        <svg class="w-4 h-4 ml-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 9l-7 7-7-7" />
        </svg>
      </button>
      <button (click)="openAddDomainModal()" class="add-domain-button">
        <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 4v16m8-8H4" />
        </svg>
      </button>
    </div>
  </div>

  <div class="user-actions">
    <button (click)="logout()" class="logout-btn">
      <svg class="w-4 h-4 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" 
              d="M17 16l4-4m0 0l-4-4m4 4H7m6 4v1a3 3 0 01-3 3H6a3 3 0 01-3-3V7a3 3 0 013-3h4a3 3 0 013 3v1" />
      </svg>
      Logout
    </button>
  </div>
</nav>

<!-- Add Domain Modal -->
<div *ngIf="showAddDomainModal" class="fixed inset-0 z-50 overflow-y-auto" aria-labelledby="modal-title" role="dialog" aria-modal="true">
  <!-- Background backdrop with blur -->
  <div class="fixed inset-0 bg-gray-900/75 backdrop-blur-sm transition-opacity" (click)="closeAddDomainModal()"></div>

  <!-- Modal container -->
  <div class="flex min-h-full items-center justify-center p-4 text-center sm:p-0">
    <div class="relative transform overflow-hidden rounded-2xl bg-gradient-to-br from-gray-800 to-gray-900 px-6 pb-6 pt-6 text-left shadow-2xl transition-all sm:my-8 sm:w-full sm:max-w-lg sm:p-8 border border-gray-700/50">
      <!-- Close button -->
      <button
        (click)="closeAddDomainModal()"
        class="absolute right-4 top-4 text-gray-400 hover:text-gray-200 transition-colors focus:outline-none focus:ring-2 focus:ring-indigo-500 rounded-lg p-1"
        aria-label="Close modal">
        <svg class="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12" />
        </svg>
      </button>

      <!-- Modal content -->
      <div class="mt-2">
        <!-- Icon and Title -->
        <div class="flex items-center justify-center mb-6">
          <div class="flex items-center justify-center w-16 h-16 rounded-full bg-indigo-600/20 border border-indigo-500/30">
            <svg class="w-8 h-8 text-indigo-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 4v16m8-8H4" />
            </svg>
          </div>
        </div>
        
        <h3 class="text-2xl font-bold text-gray-100 text-center mb-2" id="modal-title">
          Add New Domain
        </h3>
        <p class="text-sm text-gray-400 text-center mb-6">
          Enter the domain name for your new website
        </p>

        <!-- Input field -->
        <div class="mb-6">
          <label for="domain-name" class="block text-sm font-medium text-gray-300 mb-2">
            Domain Name
          </label>
          <input
            id="domain-name"
            type="text"
            [(ngModel)]="newDomainName"
            (keyup.enter)="addNewDomain()"
            placeholder="example.com"
            autofocus
            class="block w-full rounded-lg border-0 bg-gray-700/50 py-3 px-4 text-gray-200 placeholder:text-gray-500 shadow-sm ring-1 ring-inset ring-gray-600 focus:ring-2 focus:ring-inset focus:ring-indigo-500 sm:text-sm transition-all duration-200"
          />
          <p class="mt-2 text-xs text-gray-500">
            Enter a domain name (e.g., example.com or subdomain.example.com)
          </p>
        </div>

        <!-- Action buttons -->
        <div class="flex gap-3 sm:flex-row-reverse">
          <button
            type="button"
            (click)="addNewDomain()"
            [disabled]="isSubmitting || !newDomainName.trim()"
            class="inline-flex w-full items-center justify-center rounded-lg bg-gradient-to-r from-indigo-600 to-indigo-500 px-4 py-3 text-sm font-semibold text-white shadow-lg hover:from-indigo-500 hover:to-indigo-400 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600 disabled:opacity-50 disabled:cursor-not-allowed transition-all duration-200 transform hover:scale-[1.02] active:scale-[0.98]">
            <svg *ngIf="isSubmitting" class="animate-spin -ml-1 mr-2 h-5 w-5 text-white" fill="none" viewBox="0 0 24 24">
              <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
              <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
            </svg>
            <span *ngIf="!isSubmitting">Add Domain</span>
            <span *ngIf="isSubmitting">Adding...</span>
          </button>
          <button
            type="button"
            (click)="closeAddDomainModal()"
            [disabled]="isSubmitting"
            class="inline-flex w-full items-center justify-center rounded-lg bg-gray-700/50 px-4 py-3 text-sm font-semibold text-gray-200 shadow-sm ring-1 ring-inset ring-gray-600 hover:bg-gray-700 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-gray-600 disabled:opacity-50 disabled:cursor-not-allowed transition-all duration-200">
            Cancel
          </button>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- Domain Selection Modal -->
<div *ngIf="showDomainSelectionModal" class="fixed inset-0 z-50 overflow-y-auto" aria-labelledby="domain-modal-title" role="dialog" aria-modal="true">
  <!-- Background backdrop -->
  <div class="fixed inset-0 bg-gray-900/60 backdrop-blur-sm transition-opacity" (click)="closeDomainSelectionModal()"></div>

  <!-- Modal container -->
  <div class="flex min-h-full items-center justify-center p-3 sm:p-4">
    <div class="relative w-full max-w-md transform overflow-hidden rounded-xl bg-gray-800 shadow-2xl transition-all border border-gray-700/50" 
         (click)="$event.stopPropagation()">
      <!-- Header -->
      <div class="flex items-center justify-between border-b border-gray-700/50 px-4 py-3 sm:px-5 sm:py-3.5">
        <h3 class="text-lg font-semibold text-gray-100" id="domain-modal-title">
          Select Domain
        </h3>
        <button
          (click)="closeDomainSelectionModal()"
          class="text-gray-400 hover:text-gray-200 transition-colors focus:outline-none focus:ring-2 focus:ring-indigo-500 rounded-lg p-1"
          aria-label="Close modal">
          <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12" />
          </svg>
        </button>
      </div>

      <!-- Modal content -->
      <div class="px-4 py-4 sm:px-5 sm:py-5">
        <!-- Domain list -->
        <div class="space-y-2 max-h-[60vh] overflow-y-auto pr-1 -mr-1">
          <div *ngIf="domains.length === 0" class="text-center py-6 text-gray-400 text-sm">
            <svg class="w-8 h-8 mx-auto mb-2 opacity-50" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M3 12l2-2m0 0l7-7 7 7M5 10v10a1 1 0 001 1h3m10-11l2 2m-2-2v10a1 1 0 01-1 1h-3m-6 0a1 1 0 001-1v-4a1 1 0 011-1h2a1 1 0 011 1v4a1 1 0 001 1m-6 0h6" />
            </svg>
            <p>No domains available</p>
          </div>
          <div *ngFor="let domain of domains" 
               (click)="selectDomain(domain)"
               class="group flex items-center justify-between px-3 py-2.5 sm:px-4 sm:py-3 rounded-lg bg-gray-700/40 hover:bg-gray-700 cursor-pointer transition-all duration-150 border border-gray-600/30 hover:border-indigo-500/50 hover:shadow-md">
            <div class="flex items-center min-w-0 flex-1">
              <svg class="w-4 h-4 text-gray-400 mr-2 flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M3 12l2-2m0 0l7-7 7 7M5 10v10a1 1 0 001 1h3m10-11l2 2m-2-2v10a1 1 0 01-1 1h-3m-6 0a1 1 0 001-1v-4a1 1 0 011-1h2a1 1 0 011 1v4a1 1 0 001 1m-6 0h6" />
              </svg>
              <span class="text-gray-200 font-medium text-sm sm:text-base truncate">{{ domain.name }}</span>
              <span *ngIf="selectedDomain === domain.name" class="ml-2 px-2 py-0.5 text-xs font-medium text-indigo-400 bg-indigo-500/10 rounded">
                Active
              </span>
            </div>
            <button 
              (click)="confirmDeleteDomain(domain, $event)"
              class="ml-3 p-1.5 sm:p-2 text-red-400 hover:text-red-300 hover:bg-red-500/10 rounded-md transition-all duration-150 focus:outline-none focus:ring-2 focus:ring-red-500 flex-shrink-0 opacity-70 sm:opacity-0 sm:group-hover:opacity-100"
              aria-label="Delete domain">
              <svg class="w-4 h-4 sm:w-5 sm:h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16" />
              </svg>
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- Delete Confirmation Modal -->
<app-confirm-modal
  [show]="showDeleteConfirmModal"
  title="Delete Domain"
  [message]="'Are you sure you want to delete the domain \'' + (domainToDelete?.name || '') + '\'? This action cannot be undone.'"
  (onConfirm)="deleteDomain()"
  (onCancel)="cancelDeleteDomain()">
</app-confirm-modal> 